import axiosInterceptor from "../../utils/axiosInterseptor";

export const getTestimonialRoute = (queryParam) =>
  axiosInterceptor.get("/admin/testimonialListing" + queryParam);
